/**
 * window.tOr(key, fallback, params): translate a dotted key, or return the
 * fallback. A lookup that is not a function, or that returns the key, an empty
 * string or a non-string, counts as a miss. window.I18n.t is read before
 * window.t, which another global can overwrite.
 *
 * Consumers call it without a guard, so it must sit in the webpack `interpals`
 * entry ahead of every consumer. time-utils.js loads earlier and keeps a guard.
 */
(function () {
  'use strict';

  function lookup(owner, key, params) {
    if (!owner || typeof owner.t !== 'function') {
      return null;
    }
    var s = owner.t(key, params);
    return typeof s === 'string' && s && s !== key ? s : null;
  }

  window.tOr = function (key, fallback, params) {
    var i18n = window.I18n;
    var owner = i18n && typeof i18n.t === 'function' ? i18n : window;
    return lookup(owner, key, params) || fallback;
  };
})();
